import React from 'react';
import {Route, Routes} from 'react-router-dom';

import ViewRequisition from "./ViewRequisition";
import DevelopmentsPage from "./pages/DevelopmentsPage";
import UnitsPage from "./pages/UnitsPage";


import CreateRequisitionReviewPage from './pages/CreateRequisitionReviewPage';
import ProcurementProcess from './components/ProcurementProcessDashboard';
import CreateRequisitionPage from './pages/CreateRequisitionPage';
import SuppliersPage from './pages/SuppliersPage';
import ProcurementProcessDetailsPage from './pages/ProcurementProcessDetailsPage';
import RequisitionsPage from './pages/RequisitionsPage';
import PurchaseOrdersPage from './pages/PurchaseOrdersPage';

const ProcurementRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<ProcurementProcess />} />
      <Route path="/create-requisition" element={<CreateRequisitionPage />} />
      <Route path="/RaisePurchaseRequisition/:uuid" element={<CreateRequisitionPage />} />
      <Route path="/requisitions" element={<RequisitionsPage />} />
      <Route path="/purchase-orders" element={<PurchaseOrdersPage />} />
      <Route path="/CorrectPurchaseRequisition/:uuid" element={<CreateRequisitionPage />} />
      <Route path="/create-procurement-request" element={<CreateRequisitionPage />} />
      <Route path="/SiteManagerReviewPurchaseRequisition/:uuid" element={<ViewRequisition />} />
      <Route path="/ProjectManagerReviewPurchaseRequisition/:uuid" element={<ViewRequisition />} />
      <Route path="/CPOPicksSupplier/:uuid" element={<ViewRequisition />} />
      <Route path="/PCToUploadQuotations/:uuid" element={<ViewRequisition />} />
      <Route path="/PMToReviewProcurementApplication/:uuid" element={<ViewRequisition />} />
      <Route path="/ProChairReviewsSupplierChoice/:uuid" element={<ViewRequisition />} />
      <Route path="/PMToIssuePurchaseOrder/:uuid" element={<ViewRequisition />} />
      <Route path="/CFOAllocateFunds/:uuid" element={<ViewRequisition />} />
      <Route path="/COOToApprove/:uuid" element={<ViewRequisition />} />
      <Route path="/CEOToApprove/:uuid" element={<ViewRequisition />} />
      <Route path="/procurementProcess/:uuid" element={<ProcurementProcessDetailsPage />} />
      <Route path="/developments" element={<DevelopmentsPage />} />
      <Route path="/units" element={<UnitsPage />} />
      <Route path="/create-requisition-review" element={<CreateRequisitionReviewPage />} />
      <Route path="/procurement-process-dashboard" element={<ProcurementProcess />} />
      <Route path="/stakeholders" element={<SuppliersPage />} />


    </Routes>
  );
}

export default ProcurementRoutes;
